import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getYearOptions, monthOptions } from '../../../utils/helpers';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { CompanyService } from '../../../services/company.service';
import { EmployeeLocalService } from '../../services/employee.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss'],
})
export class ContractComponent {
  dataSource: any[] = [];
  mostrar: boolean = false;
  dataToEdit: any = null;
  mostrarModalValidar: boolean = false;
  mostrarModalEditar: boolean = false;
  mostrarModalDetalle: boolean = false;
  dataDetail: any = null;
  dataDetailContract: any = null;

  viewDeleted: boolean = false;
  contractId: number = 0;

  // MES 
  monthOptions: IComboBase[] = [{ key: '00', text: 'Todos' }, ...monthOptions];
  currentMonth: IComboBase | null = null;
  selectedMonth: IComboBase | null = null;
  
  // AÑO
  yearOptions: IComboBase[] = [];
  selectedYear: IComboBase | null = null;
  
  isLoading: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  
  // Término de búsqueda
  searchTerm = '';
  
  userData: any = null;

  // Fila seleccionada
  selectedRowId: number | null = null;
  selectedRow: any = null;

  headerClasses: { [key: string]: string } = {
    '1': 'header-keola',
    '2': 'header-inresort',
    '3': 'header-inclub',
    '4': 'header-ribera',
    '5': 'header-keolafood',
    '6': 'header-valle',
  };

  currentHeaderClass: string = 'header-keola';

  constructor(
    private employeeLocalService: EmployeeLocalService,
    private companyService: CompanyService,
    private router: Router
  ) {
    this.currentMonth = this.monthOptions[0];
    this.selectedMonth = { key: '00', text: 'Todos' };

    this.yearOptions = getYearOptions();
    this.selectedYear = this.yearOptions.find((y) => y.key === new Date().getFullYear().toString()) || null;
  }

  tabs: IComboBase[] = [];
  selectedTabKey: string | null = null;

  displayedColumns = [
    { key: 'employeeName', header: 'Empleado' },
    { key: 'jobPositionName', header: 'Cargo' },
    { key: 'salary', header: 'Sueldo' },
    { key: 'startDateContract', header: 'F. Inicio' },
    { key: 'endDate', header: 'F. Fin' },
    { key: 'stateContract', header: 'Status' },
    { key: 'fileContract', header: 'Contrato' },
  ];

  actionButtons = [
    {
      icon: (row: any) =>
        row.stateContractId === 3 ? 'pi pi-eye' : 'pi pi-check-square',
      color: '#ED672A',
      tooltip: (row: any) =>
        row.stateContractId === 3 ? 'Detalle' : 'Validar',
      action: (row: any) => {
        this.dataToEdit = {
          ...row,
          empresa: this.getRowCompany(row),
        };
        this.mostrarModalValidar = true;
      },
      visible: (row: any) => this.hasContract(row),
    },
    {
      icon: 'pi pi-pen-to-square',
      color: '#ED672A',
      tooltip: 'Editar',
      action: (row: any) => {
        this.dataToEdit = {
          ...row,
          empresa: this.getRowCompany(row),
        };
        this.mostrarModalEditar = true;
      },
      visible: (row: any) => this.hasContract(row) && row.stateContractId !== 3,
    },
    {
      icon: 'pi pi-trash',
      color: '#ED672A',
      tooltip: 'Eliminar',
      action: (row: any) => {
        this.contractId = row.solicitudId;
        this.viewDeleted = true;
      },
      visible: (row: any) => this.hasContract(row) && row.stateContractId !== 3,
    },
    {
      icon: (row: any) =>
        this.hasContract(row) ? 'pi pi-exclamation-triangle' : 'pi pi-file-plus',
      color: '#f59e0b',
      tooltip: (row: any) =>
        row.missingInfoSummary || 'Falta completar información del contrato',
      action: (row: any) => this.completeMissingContractInfo(row),
      visible: (row: any) => this.hasMissingContractInfo(row),
    },
  ];

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }
    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.tabs = data;
        this.selectedTabKey = this.tabs[0].key;
        this.onTabSelected(this.selectedTabKey);
      },
      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
        this.filterData();
      },
    });
  }

  onDialogClose() {
    this.mostrar = false;
  }

  onDialogDetailClose() {
    this.mostrarModalDetalle = false;
    this.mostrarModalValidar = false;
    this.dataDetail = null;
  }

  onMonthChange(selected: IComboBase): void {
    this.selectedMonth = selected;
    this.filterData(true);
  }

  onYearChange(selected: IComboBase): void {
    this.selectedYear = selected;
    this.filterData(true);
  }

  onSearch(query: string): void {
    this.searchTerm = query;
    this.filterData(true);
  }

  filterData(resetPage: boolean = false): void {
    if (resetPage) {
      this.pageIndex = 0;
    }

    this.isLoading = true;

    const filters = {
      search: this.searchTerm || null,
      month: this.selectedMonth?.key == '00' ? null : this.selectedMonth?.key,
      year: this.selectedYear?.key || null,
      companyId: this.selectedTabKey || null,
      employeeState: true,
      includeEmployeesWithoutContract: true,
      page: this.pageIndex,
      size: this.pageSize,
    };

    this.employeeLocalService.postContractByCompany(filters).subscribe({
      next: (response) => {
        this.dataSource = response.content;
        this.pageIndex = response.page.page;
        this.pageSize = response.page.size;
        this.totalElements = response.page.totalElements;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  onTabSelected(tabKey: string): void {
    this.selectedTabKey = tabKey;
    this.currentHeaderClass = this.headerClasses[tabKey] || 'header-keola';
    this.filterData(true);
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterData();
  }

  onRowSelected(row: any): void {
    this.selectedRowId = row.contractId;
    this.selectedRow = row;
  }

  onRegisterComplete(): void {
    this.filterData();
  }

  onUpdateStateComplete(): void {
    this.filterData();
  }

  onEditComplete(): void {
    this.filterData();
  }

  onDeleteComplete(): void {
    this.filterData();
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    const isoDateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return `${day}/${month}/${year}`;
    }

    // Mapeo de nombres de meses en inglés a números
    const monthsMap: { [key: string]: string } = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };

    // Extraer los datos de la fecha usando una expresión regular
    const dateParts = dateString.match(/(\w+)\s(\d+)\sdel\s(\d+)/);
    if (!dateParts) return dateString;

    const month = monthsMap[dateParts[1]];
    const day = dateParts[2].padStart(2, '0');
    const year = dateParts[3].slice(-2);

    return `${day}/${month}/${year}`;
  }

  extractFileName(fileUrl: string): string {
    const lastDashIndex = fileUrl.lastIndexOf('-', fileUrl.lastIndexOf('.'));
    const fileName = fileUrl.substring(lastDashIndex + 1);
    return fileName;
  }

  onDetail(row: any) {
    if (!this.hasContract(row)) {
      this.registerPendingContract(row);
      return;
    }

    this.dataDetailContract = row;
    this.router.navigate([
      `/dashboard/employee/contract/detail/${this.dataDetailContract.employeeId}`,
    ]);
  }

  hasContract(row: any): boolean {
    return row?.hasContract !== false && !!row?.contractId;
  }

  hasMissingContractInfo(row: any): boolean {
    const contractFileIsRequired =
      this.hasContract(row) &&
      row?.stateContractId !== 1 &&
      row?.stateContractId !== 7;

    return (
      !this.hasContract(row) ||
      row?.requiresContract === true ||
      row?.hasMissingRequiredInfo === true ||
      row?.status === 'PENDING_CONTRACT' ||
      (contractFileIsRequired && !row?.fileContract)
    );
  }

  isSelected(row: any): boolean {
    return this.selectedRow === row;
  }

  getEmployeeName(row: any): string {
    const fullName = [row?.employeeNames, row?.employeeLastNames]
      .filter(Boolean)
      .join(' ');
    return row?.employeeName || fullName || '-';
  }

  getContractStatus(row: any): string {
    if (!this.hasContract(row)) {
      return row?.missingInfoSummary || 'Empleado sin contrato';
    }

    return row?.stateContract || row?.status || '-';
  }

  getContractStatusClass(row: any): string {
    if (this.hasMissingContractInfo(row)) {
      return 'pending';
    }

    const status = (row?.stateContract || row?.status || '')
      .toString()
      .toLowerCase();

    if (row?.stateContractId === 3 || /valid|aprobad|activo|vigente|acept/.test(status)) {
      return 'approved';
    }

    if (row?.stateContractId === 2 || /enviado|revision|revisi[oó]n|proceso/.test(status)) {
      return 'sent';
    }

    if (/rechaz|vencid|finaliz|cancel|invalid/.test(status)) {
      return 'rejected';
    }

    if (/observ|warning|pend/.test(status)) {
      return 'pending';
    }

    return 'neutral';
  }

  getRowCompany(row: any): IComboBase | undefined {
    const companyId = row?.companyId?.toString() || this.selectedTabKey;
    return this.tabs.find((tab) => tab.key?.toString() === companyId);
  }

  registerPendingContract(row: any): void {
    if (!row?.employeeId) return;

    this.router.navigate(['/dashboard/employee/contract/register'], {
      state: { employeeId: row.employeeId },
    });
  }

  completeMissingContractInfo(row: any): void {
    if (!this.hasContract(row)) {
      this.registerPendingContract(row);
      return;
    }

    this.dataToEdit = {
      ...row,
      empresa: this.getRowCompany(row),
    };
    this.mostrarModalEditar = true;
  }
}
